import { createFileRoute } from '@tanstack/react-router';

function PetWebHome() {
  return <div>Pet Web</div>;
}

export const Route = createFileRoute('/')({
  component: PetWebHome,
});
